import { Stack, styled } from "@mui/material";

export const AuditTrailWrapper = styled(Stack)(({ theme }) => {
    return {
        gap: "var(--flex-gap)",
        overflow: "hidden",
        "& .filter-bar": {
            padding: "var(--basic-padding)",
            backgroundColor: "var(--light-color)",
            borderRadius: "16px",
            display: "flex",
            gap: "var(--flex-gap)",
            justifyContent: "space-between",
            alignItems: "flex-start",
            [theme.breakpoints.down("laptop")]: {
                flexDirection: "column",
                alignItems: "stretch",
            }
        },
        "& fieldset": {
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            overflow: "hidden",
            flex: 1,
        },
        "& .audit-trail-table-box": {
            "& .MuiTableContainer-root": {
                borderRadius: "16px",
                "& .MuiTableHead-root": {
                    "& .MuiTableCell-root": {
                        whiteSpace: "nowrap",
                    }
                }
            },
        },
    }
})